////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const kioskRacksRequest = {
	resetDataKioskRacksRequest: () => ({
		type: ActionsTypes.RESET_DATA_KIOSK_RACKS_REQUEST,
	}),
	getKioskRacksRequest: (idKioskProduction) => ({
		type: ActionsTypes.GET_KIOSK_RACKS_REQUEST,
		payload: {
			idKioskProduction,
		},
	}),
	getKioskRacksRequestSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_RACKS_REQUEST_SUCCESS,
		payload: {
			data,
		},
	}),
	getKioskRacksRequestFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_RACKS_REQUEST_FAILURE,
		payload: {
			error,
		},
	}),
	getKioskRacksRequestForm: () => ({
		type: ActionsTypes.GET_KIOSK_RACKS_REQUEST_FORM,
	}),
	getKioskRacksRequestFormSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_RACKS_REQUEST_FORM_SUCCESS,
		payload: {
			data,
		},
	}),
	getKioskRacksRequestFormFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_RACKS_REQUEST_FORM_FAILURE,
		payload: {
			error,
		},
	}),
	postKioskRacksRequestAddRack: (idKioskProduction, data) => ({
		type: ActionsTypes.POST_KIOSK_RACKS_REQUEST_ADD_RACK,
		payload: {
			idKioskProduction,
			data,
		},
	}),
	postKioskRacksRequestAddRackSuccess: (data) => ({
		type: ActionsTypes.POST_KIOSK_RACKS_REQUEST_ADD_RACK_SUCCESS,
		payload: {
			data,
		},
	}),
	postKioskRacksRequestAddRackFailure: (error) => ({
		type: ActionsTypes.POST_KIOSK_RACKS_REQUEST_ADD_RACK_FAILURE,
		payload: {
			error,
		},
	}),
	postKioskRacksRequestUpdateRack: (idRack, data) => ({
		type: ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_RACK,
		payload: {
			idRack,
			data,
		},
	}),
	postKioskRacksRequestUpdateRackSuccess: (data) => ({
		type: ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_RACK_SUCCESS,
		payload: {
			data,
		},
	}),
	postKioskRacksRequestUpdateRackFailure: (error) => ({
		type: ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_RACK_FAILURE,
		payload: {
			error,
		},
	}),
	postKioskRacksRequestUpdateRequest: (idRequest, data) => ({
		type: ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST,
		payload: {
			idRequest,
			data,
		},
	}),
	postKioskRacksRequestUpdateRequestSuccess: (data) => ({
		type: ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST_SUCCESS,
		payload: {
			data,
		},
	}),
	postKioskRacksRequestUpdateRequestFailure: (error) => ({
		type: ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST_FAILURE,
		payload: {
			error,
		},
	}),
	putKioskRacksRequestDeleteRequest: (idRequest) => ({
		type: ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST,
		payload: {
			idRequest,
		},
	}),
	putKioskRacksRequestDeleteRequestSuccess: (data) => ({
		type: ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST_SUCCESS,
		payload: {
			data,
		},
	}),
	putKioskRacksRequestDeleteRequestFailure: (error) => ({
		type: ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST_FAILURE,
		payload: {
			error,
		},
	}),
	putKioskRacksRequestDeleteRack: (idRack) => ({
		type: ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_RACK,
		payload: {
			idRack,
		},
	}),
	putKioskRacksRequestDeleteRackSuccess: (data) => ({
		type: ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_RACK_SUCCESS,
		payload: {
			data,
		},
	}),
	putKioskRacksRequestDeleteRackFailure: (error) => ({
		type: ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_RACK_FAILURE,
		payload: {
			error,
		},
	}),
}

export default kioskRacksRequest
